if(!customElements.get('localization-form-new')) {
  customElements.define(
    'localization-form-new',
    class LocalizationFormNew extends HTMLElement {
      constructor() {
        super();
        this.selectorForm = this.querySelector('form');
        this.toggler = this.querySelector('[data-localization-dropdown-toggler]');
        this.dropdown = this.querySelector('[data-localization-dropdown]');
        this.languageSelect = this.querySelector('select[name="language_code"]');
        this.languageCustomSelect = this.querySelector('[data-language-options]');
        this.languageToggler = this.querySelector('[data-language-dropdown-toggler]');
        this.countryToggler = this.querySelector('[data-country-dropdown-toggler]');
        this.languageFlag = this.querySelector('[data-language-flag]');

        this.customSelect = this.querySelectorAll('custom-select');

        this.toggler.addEventListener('click', this.onTogglerClick.bind(this));
        this.customSelect.forEach((customSelect) => {
          this.enableCustomSelect(customSelect);
        })

        this.selectorForm.addEventListener('submit', this.onSwitcherSubmit.bind(this));

        this.setLanguageOptions();
      }

      onTogglerClick(evt) {
        evt.preventDefault();

        if(this.toggler.ariaExpanded == 'true') {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      onSwitcherSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const formData = new FormData(this.selectorForm);
        const countryCode = formData.get('country_code').toLowerCase();
        const languageCode = formData.get('language_code').toLowerCase();
        const targetRoot = this.getTargetRoot({
          countryCode,
          languageCode
        })

        if(targetRoot == Shopify.routes.root) {
          this.closeCustomSelectDropdown();
          return;
        }

        if(targetRoot == "/") {
          document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root, "/")
          return;
        }

        if(Shopify.routes.root !== '/') {
          document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root, `${targetRoot}/`)
          return;
        }

        document.location.href = document.location.origin + targetRoot + document.location.pathname;
      }

      getTargetRoot({countryCode, languageCode}) {
        let targetRoot = "/";

        if(countryCode !== "us") {
          return `/${languageCode}-${countryCode}`
        }

        if(languageCode !== "en") {
          return `/${languageCode}`
        }

        return targetRoot;
      }

      openDropdown() {
        this.dropdown.removeAttribute('hidden');
        this.toggler.ariaExpanded = "true";
      }

      closeDropdown() {
        this.dropdown.setAttribute('hidden', true);
        this.toggler.ariaExpanded = "false";
      }

      setLanguageOptions() {
        this.languageToggler.querySelector('[data-selected-text]').innerText = window.Weglot.getLanguageName(window.Weglot.getCurrentLang());
        this.languageFlag.innerText = window.Weglot.getCurrentLang().toUpperCase();
        const languages = window.Weglot.options.languages.map((language) => language.language_to);
        languages.unshift(window.Weglot.options.language_from);

        languages.forEach((language) => {
          const option = document.createElement('option');
          option.value = language;
          option.text = window.Weglot.getLanguageName(language);
          if(language == window.Weglot.getCurrentLang()) {
            option.selected = true;
          }
          this.languageSelect.appendChild(option);

          const customOption = document.createElement('li');
          customOption.setAttribute('value', language);
          customOption.innerText = window.Weglot.getLanguageName(language);
          customOption.classList.add('custom-select__option');

          if(language == window.Weglot.getCurrentLang()) {
            customOption.setAttribute('aria-current', true);
          }

          this.languageCustomSelect.appendChild(customOption);
          this.languageToggler
        })
      }

      enableCustomSelect(customSelect) {
        const togglerButton = customSelect.querySelector('[data-custom-select-toggler]');
        const regularSelect = customSelect.querySelector('select');
        const customSelectDropdown = customSelect.querySelector('[data-custom-select-options]');

        customSelectDropdown.addEventListener('click', (evt) => {
          regularSelect.value = evt.srcElement.getAttribute('value');
          regularSelect.dispatchEvent(new Event('change'));
        })

        regularSelect.addEventListener('change', (evt) => {
          const customValues = customSelectDropdown.querySelectorAll('li');
          customValues.forEach((element) => {
            if(element.getAttribute('value') == evt.target.value) {
              element.setAttribute('aria-current', true);
              togglerButton.querySelector('[data-selected-text]').innerHTML = element.innerHTML;
            } else {
              element.removeAttribute('aria-current');
            }
          })
          this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
        })

        togglerButton.addEventListener('click', (evt) => {
          if(togglerButton.ariaExpanded == 'true') {
            this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
          } else {
            this.openCustomSelectDropdown(togglerButton, customSelectDropdown);

          }
        })
      }

      openCustomSelectDropdown(togglerButton,dropdown) {
        dropdown.removeAttribute('hidden')
        togglerButton.setAttribute('aria-expanded', 'true');
      }

      closeCustomSelectDropdown(togglerButton,dropdown) {
        dropdown.setAttribute('hidden', true)
        togglerButton.setAttribute('aria-expanded', 'false');
      }
    }
  )
}